import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import {  throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  authUrl: string = environment.apiBaseUrl;
  // authUrlV2: string = environment.apiBaseUrlV2;

  private http = inject(HttpClient);

  // login api
  public UserLogin(bodyData: any, context?: HttpContext) {
    const endPoint = `${this.authUrl}/auth/v2/login`;
    return this.http.post(endPoint, bodyData, { context }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }


  // change password api
  public ChangePassword(bodyData: any) {
    const endPoint = `${this.authUrl}/auth/v2/set-password`;
    return this.http.post(endPoint, bodyData).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }


// logout api
  public UserLogout(bodyData: any) {
    const endPoint = `${this.authUrl}/auth/logout`;
    return this.http.post(endPoint, bodyData).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

// refresh token api
  public RefreshToken() {
    const session = JSON.parse(localStorage.getItem('user_details') || '{}');

    return this.http.post<any>(
      `${this.authUrl}/auth/refresh-token`,
      {
        refreshToken: session.tokens.refreshToken,
        userId: session.user.id
      }
    );
  }



}
